// main.ts
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { captureShareTarget } from 'app/utils/lead/share-target';

// "Compartir" desde WhatsApp u otra app hacia la PWA: guardar el contenido antes de que arranque el router.
captureShareTarget();

bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
);


// if (environment.hmr) {
//     if (module["hot"]) {
//         hmrBootstrap(module, bootstrap);
//     } else {
//         console.error("HMR is not enabled for webpack-dev-server!");
//         console.log("Are you using the --hmr flag for ng serve?");
//     }
// } else {
//     bootstrap().catch((err) => console.log(err));
// }
